import { detectMobile, detectWebView } from "./VueMobileDetection";

export default {
    install: (app) => {
        app.config.globalProperties.$isMobile = detectMobile;
        app.config.globalProperties.$isWebView = detectWebView;
    },
};
